
/* CRAFTYLUMI - COUNTDOWN */

(function () {
  function initCountdown() {
    document.querySelectorAll(
      '[data-craftylumi-timer]'
    ).forEach(function (timer) {
      if (timer.dataset.started === 'true') return;
      timer.dataset.started = 'true';

      const duration = 3 * 60 * 60 + 30 * 60;
      const start = Date.now();

      function update() {
        const elapsed = Math.floor(
          (Date.now() - start) / 1000
        );
        const remaining = Math.max(0, duration - elapsed);

        const h = Math.floor(remaining / 3600);
        const m = Math.floor((remaining % 3600) / 60);
        const s = remaining % 60;

        timer.textContent = [h, m, s]
          .map(n => String(n).padStart(2, '0'))
          .join(':');

        return remaining > 0;
      }

      update();

      const interval = setInterval(function () {
        if (!timer.isConnected || !update()) {
          clearInterval(interval);
        }
      }, 1000);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCountdown);
  } else {
    initCountdown();
  }

  document.addEventListener('shopify:section:load', initCountdown);
})();
